import { all } from 'redux-saga/effects';

import { cancelProvisionWatcher } from './cancel_provision.saga'
import { createProvisionBySavedCardWatcher } from './create_provision_by_saved_card.saga'
import { getPosRatioSagaWatcher } from './get_pos_ratio.saga'
import { getReceiptDetailSagaWatcher } from './get_receipt_detail.saga'
import { getVirtualPosSagaWatcher } from './get_virtual_pos.saga'
import { listCardsSagaWatcher } from './list_cards.saga'
import { purchaseSagaWatcher} from './purchase.saga'
import { purchaseByProvisionSagaWatcher } from './purchase_by_provision.saga'
import { purchaseBySavedCardSagaWatcher } from './purchase_by_saved_card.saga'
import { refundSagaWatcher } from './refund.saga'
import { removeCardSagaWatcher } from './remove_card.saga'
import { saveCardSagaWatcher } from './save_card.saga'
export default function* paymentSaga() {
    yield all([
        cancelProvisionWatcher(),
        createProvisionBySavedCardWatcher(),
        getPosRatioSagaWatcher (),
        getReceiptDetailSagaWatcher (),
        getVirtualPosSagaWatcher (),
        listCardsSagaWatcher (),
        purchaseSagaWatcher(),
        purchaseByProvisionSagaWatcher(),
        purchaseBySavedCardSagaWatcher (),
        refundSagaWatcher (),
        removeCardSagaWatcher (),
        saveCardSagaWatcher (),
    ]);
}